


import { create } from "zustand";

export const useAdminZoneStore = create((set, get) => ({
    selectedZones: [],

    addZone: (zoneObj, isSingleSelect = false) => {
        const prev = get().selectedZones;

        // Single select mode → always replace
        if (isSingleSelect) {
            return set({ selectedZones: [zoneObj] });
        }

        // Prevent duplicates
        const exists = prev.some((z) => z?.id === zoneObj?.id);
        if (exists) return;

        set({ selectedZones: [...prev, zoneObj] });
    },

    removeZone: (id) =>
        set((state) => ({
            selectedZones: state.selectedZones.filter((item) => item?.id !== id),
        })),

    clearZones: () => set({ selectedZones: [] }),

    getZones: () => get().selectedZones,
}));

